import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Admin_Bulk_Delete_Event_failure, Admin_Bulk_Delete_Event_request, Admin_Bulk_Delete_Event_success } from "../../../Reducer/BulkDeleteEvent/BulkDeleteEvent";
import { AdminEventListAPI } from "./EventList";
import { EventDashboardAPI } from "./EventDashboardList";

export const EventBulkDeleteEventAPI = (payload) => async (dispatch, getState) => {
    const admineventid=localStorage.getItem("admineventid")
    const auth_token = localStorage.getItem("auth_token")
    dispatch(Admin_Bulk_Delete_Event_request())
    try {
        const { data } = await axios.post(`${APIURL.adminbulkdeleteevent}`,payload,{
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
                "event-slug":Headers?.["event-slug"],
                "Content-type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${auth_token}`
            },
        })
        dispatch(Admin_Bulk_Delete_Event_success(data))
        dispatch(AdminEventListAPI())
        dispatch(EventDashboardAPI(admineventid))
    } catch (error) {
        // reloadHandler(error?.response?.status)
        dispatch(Admin_Bulk_Delete_Event_failure(error?.response?.data))
    }
}


  